import { render } from "./AddProduct.vue?vue&type=template&id=1bb18af2&scoped=true&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=1bb18af2&lang=css"
import "./AddProduct.vue?vue&type=style&index=1&id=1bb18af2&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb18af2"]])

export default __exports__